// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200521/js/" + chunkId + "." + {"44":"7cdf1575","225":"a0901569","481":"5b4786b6","486":"1f18e2a5","770":"c4a7c878"}[chunkId] + ".0.5105858646173526.chunk.js";
};